/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectFormatExternalInterfaceKey } from './businessObjectFormatExternalInterfaceKey';
import { ExternalInterfaceKey } from './externalInterfaceKey';


export interface ExternalInterface { 
    externalInterfaceKey: ExternalInterfaceKey;
    /**
     * The external interface display name
     */
    displayName: string;
    /**
     * The external interface description
     */
    description?: string;
    /**
     * A list of business object format to external interface mappings
     */
    businessObjectFormatExternalInterfaces?: Array<BusinessObjectFormatExternalInterfaceKey>;
}
